var map = {
	"./coinStake.json": 57637,
	"./mint.json": 88520,
	"./nft.json": 90360,
	"./privateMint.json": 79371,
	"./rechargeAndWithdrawContract.json": 63922,
	"./stakeClaim.json": 20090,
	"./token.json": 95713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18779;